export default "__VITE_PUBLIC_ASSET__27b86cfa__"